// extracted by mini-css-extract-plugin
export default {"label":"tz_label__7lcd1","note":"tz_note__baLh9"};